import { IconForwardArrow } from "@repo/assets/images";
import { LoginWrapper, SectionHeading } from "@repo/components";
import { Button } from "@repo/ui";
import { useTranslations } from "next-intl";
const CheckoutLogin = ({
  session,
  handleCheckoutSignIn,
  handleGuestSelection
}) => {
  const tLogin = useTranslations("LoginPage");
  const tCheckout = useTranslations("Checkout");
  return <>
      <SectionHeading title={tLogin("Login_To_Your_Account")} data-sentry-element="SectionHeading" data-sentry-source-file="CheckoutLogin.jsx" />
      <div className="border-supportiveDarkGray mt-3 md:border">
        <div className="mx-auto max-w-md md:py-10">
          <LoginWrapper variant="secondary" session={session} handleCheckoutSignIn={handleCheckoutSignIn} data-sentry-element="LoginWrapper" data-sentry-source-file="CheckoutLogin.jsx" />
          <div className="border-lightgray border-t pt-4">
            <Button size="md" type="button" className="flex w-full items-center justify-center" variant="secondary" onClick={handleGuestSelection} data-sentry-element="Button" data-sentry-source-file="CheckoutLogin.jsx">
              {tCheckout("Checkout_As_A_Guest")}{" "}
              <IconForwardArrow className="rtl:rotate-180" data-sentry-element="IconForwardArrow" data-sentry-source-file="CheckoutLogin.jsx" />
            </Button>
          </div>
          <p className="pt-2 text-center text-sm">
            {tCheckout("Checkout_As_A_Guest_Message")}
          </p>
        </div>
      </div>
    </>;
};
export default CheckoutLogin;